export default class MarketplaceTransaction {
  marketPlace?: string;
  marketPlaceId?: string;
  marketPlaceUrl?: string;
  marketPlaceNumber?: string;
  subChannel?: string;
  subChannelNormalized?: string;
}
